module.exports = {"id":"137114","name":"Michaël Ciani","rating":"72","photo":"./data/images/photos/3/137114.png","club":{"name":"LA Galaxy","logo":"./data/images/clubs/LAGalaxy.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelCiani0.json
// module id = 2981
// module chunks = 0